import request from "@/utils/request";

// 列表查询
export function queryHandleTable(data) {
  return request({
    url: "/act/needDealt/handlePage",
    method: "post",
    data,
  });
}
